module.exports = __webpack_public_path__ + "img/mrn.60c6dc12.jpg";